// extracted by mini-css-extract-plugin
module.exports = {"text":"DeleteModal_text__1j1Lf","cancel-button":"DeleteModal_cancel-button__1Ii5n"};